import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {select, Store} from '@ngrx/store';
import {firestoreLatencyPath} from '@spout/global-web/fns';
import {DeviceDetectionState} from '@spout/global-web/models';
import {from} from 'rxjs';
import {switchMap} from 'rxjs/operators';
import {deviceState} from '../+device-detection/device-detection.selectors';
import {saveLatency} from '../+device-storage/device-storage.actions';
import {CustomFirestoreService} from '../firebase';

@Injectable({providedIn: 'root'})
export class LatencyEffects {
  loadLatencys$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(saveLatency),
        switchMap(action => {
          return this.store.pipe(
            select(deviceState),
            switchMap((device: DeviceDetectionState) => {
              return from(
                this.sptFirestore.addDoc(
                  firestoreLatencyPath(),
                  JSON.parse(
                    JSON.stringify({
                      latency: action.latency,
                      electron: device.electronVersion,
                      useragent: device.useragent,
                      desktopInformation: device.desktopInformation
                    })
                  )
                )
              );
            })
          );
        })
      );
    },
    {dispatch: false}
  );

  constructor(
    private actions$: Actions,
    private store: Store,
    private sptFirestore: CustomFirestoreService
  ) {}
}
